function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.88,22c-0.11,0-0.22,0-0.33-0.01c-0.021,0-0.05,0-0.07-0.01C14.609,21.99,14.74,22,14.88,22z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.88,21c-0.12,0-0.25,0-0.37-0.01c-0.12-0.01-0.23-0.03-0.35-0.04C14.4,20.971,14.641,21,14.88,21z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M13.6,20.98c0.02,0.01,0.05,0.01,0.07,0.01C13.78,21,13.89,21,14,21C13.86,21,13.73,20.99,13.6,20.98z  M14.83,7.05h-0.04c0.19,0.02,0.37,0.05,0.55,0.08C15.17,7.1,15,7.07,14.83,7.05z M14.641,7.03c-0.039,0-0.08-0.01-0.119-0.01 C14.351,7.01,14.18,7,14,7c0.16,0,0.32,0.01,0.47,0.03c0.11,0,0.209,0.01,0.32,0.02C14.74,7.04,14.689,7.03,14.641,7.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.83,7.05C15,7.07,15.17,7.1,15.34,7.13c-0.18-0.03-0.359-0.06-0.55-0.08c-0.11-0.01-0.21-0.02-0.32-0.02 C14.32,7.01,14.16,7,14,7c-0.27,0-0.54,0.02-0.8,0.05C6.4,7.53,1,14,1,14s5.39,6.46,12.19,6.95c0,0,0,0,0.01,0 c0.05,0.01,0.1,0.021,0.15,0.01c0.02,0,0.05,0.011,0.07,0.011c0.06,0.01,0.12,0.01,0.18,0.01C13.73,20.99,13.86,21,14,21 c0.22,0,0.43-0.01,0.641-0.029c0.069,0,0.131-0.011,0.189-0.021C21.609,20.439,27,14,27,14S21.609,7.56,14.83,7.05z M2.35,14 c1.06-1.11,3.48-3.4,6.57-4.8C7.72,10.46,7,12.14,7,14c0,1.859,0.72,3.54,1.92,4.8C5.83,17.4,3.41,15.109,2.35,14z M14.721,19.95 C14.48,19.971,14.24,20,14,20c-0.12,0-0.25,0-0.37-0.01s-0.23-0.03-0.35-0.04C10.31,19.6,8,17.07,8,14c0-3.07,2.31-5.6,5.28-5.95 C13.52,8.03,13.76,8,14,8c0.12,0,0.25,0.01,0.37,0.01c0.12,0.01,0.229,0.03,0.351,0.04C17.68,8.4,20,10.93,20,14 C20,17.07,17.68,19.6,14.721,19.95z M19.09,18.8C20.279,17.54,21,15.859,21,14c0-1.86-0.721-3.54-1.91-4.8 c3.08,1.41,5.49,3.69,6.551,4.8C24.58,15.109,22.17,17.391,19.09,18.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.79,7.05c-0.11-0.01-0.21-0.02-0.32-0.02c0.021-0.01,0.03-0.01,0.051-0.01c0.039,0,0.08,0.01,0.119,0.01 C14.689,7.03,14.74,7.04,14.79,7.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M15.34,7.13c-0.18-0.03-0.359-0.06-0.55-0.08h0.04C15,7.07,15.17,7.1,15.34,7.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M13.6,20.98c0.02,0.01,0.05,0.01,0.07,0.01C13.78,21,13.89,21,14,21C13.86,21,13.73,20.99,13.6,20.98z  M14.37,8.01C14.25,8.01,14.12,8,14,8c0.24,0,0.48,0.03,0.721,0.05C14.602,8.04,14.49,8.02,14.37,8.01z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#757575",
  cx: 14.058,
  cy: 14,
  r: 3
}));

var SvgOpenedEye = function SvgOpenedEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenedEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/opened_eye.468fac8a.svg";
export { ForwardRef as ReactComponent };